import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classNames from 'classnames';
import toast from 'react-hot-toast';

interface Props {
  value?: number | string | null;
  className?: string;
  title?: string;
}

export function IdPill({ value, className, title = 'Copy ID' }: Props) {
  const [isCopied, setIsCopied] = useState(false);

  const idString = value != null ? String(value) : '';
  if (!idString) return null;

  const handleCopy = () => {
    setIsCopied(true);
    toast.success('Copied to Clipboard');
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <CopyToClipboard text={idString} onCopy={handleCopy}>
      <div
        className={classNames(
          'inline-flex items-center h-[21px] px-2 rounded-md border border-accent bg-transparent text-accent-text tabular-nums cursor-pointer shrink-0 whitespace-nowrap transition-colors duration-150 hover:bg-tint',
          { '!border-up !text-up': isCopied },
          className
        )}
        style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 11 }}
        title={title}
        onClick={(e) => e.stopPropagation()}
      >
        {idString}
      </div>
    </CopyToClipboard>
  );
}

export default IdPill;
